import React, { useState, useEffect } from 'react';

// Hooks
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { fetchTags, deleteTag } from '~/redux/actions/tags-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';

//Utils
import { MESSAGES } from '~/utils/message';
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Components
import Table from './TagsListing';
import CreateTag from './CreateTag';
import EditTagModal from './EditTag';
import ConfirmModal from '~/components/General/ConfirmModal';
import NoRecords from '~/components/General/NoRecords';
import LimitReach from '~/components/General/LimitModal';
import OlcButton from '~/components/General/OlcButton';

// MUI Components
import { Box, Typography, Grid, GlobalStyles } from '@mui/material';

// images
import { GeneralInviteCIcon, ModalTrashIcon } from '~/assets/images';
import HashSettingsIcon from '~/assets/images/settings/hash.svg';

// styles
import './styles.scss';

const Tags = () => {
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [createTagModal, setCreateTagModal] = useState(false);
  const [editTagModal, setEditTagModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState({ title: null, id: null });
  const [limitModal, setLimitModal] = useState(false);
  const [limitMessage, setLimitMessage] = useState('');
  const [initialLoad, setInitialLoad] = useState(true);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    message: '',
    header: '',
    icon: '',
    loading: false,
    handleOk: () => {},
    handleClose: () => {},
    successButtonName: '',
  });

  const dispatch = useDispatch();
  const rowsCount = useSelector((state) => state.tagsReducers.rowsCount);
  const isLoading = useSelector((state) => state.tagsReducers.loading);

  const deleteExistingTag = async (tagId) => {
    try {
      setConfirmModal((prev) => ({ ...prev, loading: true }));
      const response = await dispatch(deleteTag(tagId));
      dispatch(fetchTags(pagination));
      dispatch(success(response.data.message));
      setConfirmModal((prev) => ({ ...prev, open: false, loading: false }));
    } catch (error) {
      dispatch(failure(error.response?.data?.message));
      setConfirmModal((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    let payload = {
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    dispatch(fetchTags(payload)).finally(() => {
      setInitialLoad(false);
    });
  }, [pagination.page, pagination.pageSize]);

  return (
    <>
      <GlobalStyles styles={{ body: { backgroundColor: '#f9fafb' } }} />
      <Box className="olcWrapper">
        <Box className="olcScreenCard">
          <Box className="olcHeaderWrap">
            <Box>
              <Typography className="pageTitle">{MESSAGES.SETTINGS.TAGS.TITLE}</Typography>
            </Box>
            <Box className="pageNewBtn">
              <OlcButton
                variant="primary"
                startIcon={<img src={GeneralInviteCIcon} alt="" />}
                onClick={() => setCreateTagModal(true)}
              >
                {MESSAGES.SETTINGS.TAGS.CREATE_BUTTON_TEXT}
              </OlcButton>
            </Box>
          </Box>
          {!isLoading && (!rowsCount || rowsCount === 0) ? (
            <Box>
              <NoRecords
                icon={
                  <img
                    src={HashSettingsIcon}
                    alt="no-records"
                    style={{ height: '40px', width: '35px' }}
                  />
                }
                title={MESSAGES?.SETTINGS?.TAGS?.NO_RECORDS_TITLE || 'No tags yet'}
                message={MESSAGES?.SETTINGS?.TAGS?.NO_TAGS_RECORDS}
              />
            </Box>
          ) : (
            // <Grid container>
            //   <Grid item lg={12} md={12} sm={12} xs={12}>
            <Table
              setEditTagModal={setEditTagModal}
              setSelectedTag={(value) => {
                setSelectedTag(value);
              }}
              updatePagination={setPagination}
              pagination={pagination}
              initialLoad={initialLoad}
              isCreateModalOpen={createTagModal}
              isDeleteModalOpen={confirmModal.open}
              onDelete={(tag) => {
                setConfirmModal({
                  open: true,
                  message: MESSAGES.SETTINGS.TAGS.DELETE.HEADING,
                  header: MESSAGES.SETTINGS.TAGS.DELETE.TITLE,
                  icon: ModalTrashIcon,
                  loading: false,
                  handleOk: () => deleteExistingTag(tag.id),
                  handleClose: () => setConfirmModal((prev) => ({ ...prev, open: false })),
                  successButtonName: MESSAGES.SETTINGS.TAGS.DELETE.SUBMIT_BUTTON,
                });
              }}
            />
            //   </Grid>
            // </Grid>
          )}
        </Box>
      </Box>
      <CreateTag
        openModal={createTagModal}
        handleCloseModal={() => setCreateTagModal(false)}
        updatePagination={setPagination}
        onLimitReached={(message) => {
          setCreateTagModal(false);
          setLimitMessage(message);
          setLimitModal(true);
        }}
      />
      <EditTagModal
        openModal={editTagModal}
        handleCloseModal={() => setEditTagModal(false)}
        selectedTag={selectedTag}
        pagination={pagination}
      />
      <LimitReach
        open={limitModal}
        onClose={() => {
          setLimitModal(false);
          setTimeout(() => setLimitMessage(''), 100);
        }}
        message={limitMessage}
        resourceType="tags"
      />
      <ConfirmModal openConfirmModal={confirmModal} />
    </>
  );
};

export default Tags;
